import { createContext, useContext } from "react";

export type RequestFormSaveContextType = {
  saveField: (path: string, value: unknown) => Promise<void>;
  saveInvitedModes: () => void;
  queueDraftSave: (path?: string) => void;
  /** Resolves false when there is nothing to save; rejects with the API error when the save fails. */
  flushSave: () => Promise<boolean>;
  isDraftSaving: boolean;
};

export const RequestFormSaveContext = createContext<RequestFormSaveContextType | null>(null);

export function useRequestFormSave(): RequestFormSaveContextType | null {
  return useContext(RequestFormSaveContext);
}

export function useRequestFormSaveOrNull(): RequestFormSaveContextType | null {
  return useContext(RequestFormSaveContext);
}
